setTimeout(function() {
  var mainSwiperDiv = document.querySelector('.main--product-page-img');
  if(mainSwiperDiv){
    var mainSwiper = new Swiper(".main--product-page-img", {
      spaceBetween: 30,
      slidesPerView: 1,
      navigation: {
        nextEl: ".main--product-swiper-button-next",
        prevEl: ".main--product-swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });
  
    // Check and update navigation after a slight delay to ensure Swiper is fully initialized
    setTimeout(function() {
      if (mainSwiper.isBeginning) {
        mainSwiper.navigation.prevEl.classList.add('swiper-button-disabled');
      }
    }, 100); // 100ms delay might be adjusted based on actual needs
  }
}, 500); // Adjust the delay to fit within your page's load lifecycle

// BeautyTap
var beautyTapSwiper = new Swiper(".beautytap", {
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  loop: true,
});

// BeautyTap
var custombloglistingSwiper = new Swiper(".custom_blog_listing", {
  slidesPerView: 3,
  spaceBetween: 25,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".blog-swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 25,
    },
    537: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 25,
    },
  },
});

var swiper = new Swiper(".main--product-img-mobile", {
  spaceBetween: 10,
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// Review slider start
var reviewSwiper = new Swiper(".review-slider", {
  slidesPerView: 2,
  spaceBetween: 30,
  pagination: {
    el: ".review-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".review-arrow-next",
    prevEl: ".review-arrow-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
  },
});
// Review slider End


// Ingredients slider start
var swiper = new Swiper(".our-ingredients-slider", {
  slidesPerView: 3,
  spaceBetween: 40,
   pagination: {
    el: ".ingredients-progress",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".ingredients-arrows-next",
    prevEl: ".ingredients-arrows-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1360: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
});
// Ingredients slider End

// Supplies Slider only on desktop start
var init = false;
var pricingCardSwiper;
function swiperCard() {
  if (window.innerWidth >= 768) {
    if (!init) {
      init = true;
      pricingCardSwiper = new Swiper(".supplies-slider", {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true,
          navigation: {
    nextEl: ".supplies-arrows-next",
    prevEl: ".supplies-arrows-prev",
  },
      });
    }
  } else if (init) {
    pricingCardSwiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);
// Supplies Slider only on desktop End



// Step Box only on desktop start
var init = false;
var stepBoxSlider;
function StepBoxCard() {
  if (window.innerWidth >= 768) {
    if (!init) {
      init = true;
      stepBoxSlider = new Swiper(".step-slider-box--wrapper", {
        slidesPerView: 2.03,
        spaceBetween: 30,
        navigation: {
          nextEl: '.step-next-btn',
          prevEl: '.step-prev-btn',
        },
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 20,
      });
    }
  } else if (init) {
    stepBoxSlider.destroy();
    init = false;
  }
}
StepBoxCard();
window.addEventListener("resize", StepBoxCard);
// Step Box only on desktop End

// Box Slider only on desktop start
var init = false;
var stepBoxSlider;
function StepBoxCard1() {
  if (window.innerWidth >= 768) {
    if (!init) {
      init = true;
      stepBoxSlider = new Swiper(".box-slider", {
        slidesPerView: 1.03,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".slider-box-progress",
          type: "progressbar",
        },
        breakpoints: {
          768: {
            slidesPerView: 1.03,
            spaceBetween: 20,
          },
          1360: {
            slidesPerView: 1.03,
            spaceBetween: 20,
          },
          1440: {
            slidesPerView: 1.08,
            spaceBetween: 40,
          },
          1440: {
            slidesPerView: 1.2,
            spaceBetween: 40,
          },
          1800: {
            slidesPerView: 1.35,
            spaceBetween: 40,
          },
          1920: {
            slidesPerView: 1.4,
            spaceBetween: 40,
          },
        },
      });
    }
  } else if (init) {
    stepBoxSlider.destroy();
    init = false;
  }
}
StepBoxCard1();
window.addEventListener("resize", StepBoxCard1);
// Box Slider only on desktop End

// Menu Close BTN start
document.querySelector('.menu-drawer-close-btn').addEventListener('click', function() {
    document.querySelector('.header__icon--menu').click();
});
// Menu Close BTN End

// Featured Product Slider start
var swiper = new Swiper(".thumnail-product-img-slider", {
  spaceBetween: 15,
  slidesPerView: 6,
  freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    280: {
      slidesPerView: 5,
      spaceBetween: 5,
    },
    768: {
      spaceBetween: 10,
      slidesPerView: 6,
    },
    992: {
      spaceBetween: 15,
      slidesPerView: 6,
    }
  },
});
var swiper2 = new Swiper(".main-product-img-slider", {
  spaceBetween: 0,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});
// Featured Product Slider End


// Featured Product section start
document.querySelectorAll('.product-variant-box').forEach(function(box) {
  box.addEventListener('click', function() {
    var varID = this.getAttribute('data-id');
    var varPrice = this.getAttribute('data-price');
    var varPriceNum = Number(varPrice);
    var totalPrice = varPriceNum / 4;
    var totalFloor = totalPrice.toFixed(2);
    var varcomPrice = this.getAttribute('data-com-price');
    var perBath = this.querySelector('.perbatn-val').textContent;
    var selectVarName = this.querySelector('p').getAttribute('data-var');
    var selectVarPerBath = this.querySelector('p + span').textContent;
    var srtickyVar = document.querySelector('.feature-sticky-variant-box--wrapper span');
    if(srtickyVar){      
      document.querySelector('.feature-sticky-variant-box--wrapper span').innerHTML = selectVarName+'<u>|</u> <b>'+selectVarPerBath+'</b>';
    }
    var shopPay = document.querySelector('.product-shop-pay-box');
    if(shopPay){
      document.querySelector('.product-shop-pay-box span').innerHTML = totalFloor;
    }
    document.querySelectorAll('.product-variant-box').forEach(function(box) {
        box.classList.remove('active');
    });
    this.classList.add('active');
    this.closest('.product__info-wrapper').querySelector('.product-variant-id').value = varID;
    this.closest('.product__info-wrapper').querySelector('#perbath').value = perBath;
    document.querySelector('.product-form__buttons .product-form__submit .com-price').innerHTML = '$'+varcomPrice;
    document.querySelector('.product-form__buttons .product-form__submit .reg-price').innerHTML = '$'+varPrice;
    document.querySelectorAll('.product-form__input input').forEach(function(slide) {
        var varName = slide.getAttribute('value');
        if(varName == selectVarName){
          slide.click();
        }
    });    
    var stickyVariantCartText = document.querySelector('.selected-feature-variant');
    if (stickyVariantCartText) {
      stickyVariantCartText.textContent = selectVarName;
    }
    setTimeout(() => {
      var subPrice = document.querySelector('.rc_widget__price--subsave').innerHTML;
      var onePrice = document.querySelector('.rc_widget__price--onetime').innerHTML;
      var mobileBtn = document.querySelector('.subSaveBtn .ProductMeta__Price');
      if (mobileBtn) {    
        document.querySelector('.subSaveBtn .ProductMeta__Price').textContent = subPrice;
        document.querySelector('.oneTimeBtn .ProductMeta__Price').textContent = onePrice;
      }
      let bundleDiv = this.closest('.bundle-product-right-col');
      if (!bundleDiv) {
        document.querySelector('[data-price-subsave]').innerHTML += " <u></u>" + selectVarName;
        document.querySelector('[data-price-onetime]').innerHTML += " <u></u>" + selectVarName;
      }
      
    }, 300);
    updateSpecialContent();

    let productParent = this.closest('.product');
    let mainBundleImg = productParent.querySelector('.main-bundle-product-img');
    
    if (mainBundleImg) {
      mainBundleImg.querySelectorAll('img').forEach(function(img) {
        let imgvariantTitle = img.getAttribute('data-variant-title');
        if (imgvariantTitle === selectVarName) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });
    }

    
   let bundleDiv = this.closest('.bundle-product-right-col');
    if (bundleDiv) {
        setTimeout(() => {
           let input = document.querySelector('.bundle-product-right-col .rc-option__subsave label');
            if (input) {
                input.checked = true; // Explicitly check the input
                input.click(); // Manually trigger change event
            }
        }, 1000);
    }
  });
});

document.querySelectorAll('.feature-sticky-variant-box--wrapper li').forEach(function(li) {
    li.addEventListener('click', function() {
        var varID = this.innerHTML;
        var parDiv = this.closest('.feature-sticky-variant-box--wrapper').querySelector('ul');
        parDiv.style.display = 'none';
        var dataTitle = this.getAttribute('data-title');
        document.querySelectorAll('.product-variant-box').forEach(function(box) {
            box.classList.remove('active');
        });
        this.closest('.feature-sticky-variant-box--wrapper').querySelector('span').innerHTML = varID;
        document.querySelectorAll('.product-variant-box').forEach(function(box) {
            var proVarTitle = box.querySelector('p').getAttribute('data-var');
            if (dataTitle === proVarTitle) {
                box.click();
            }
        });
    });
});

var stickyRightLink = document.querySelector('.feature-sticky-right a');
if (stickyRightLink) {
  stickyRightLink.addEventListener('click', function() {
    document.querySelector('.product-form__buttons button').click();
  });
}

var stickyVar = document.querySelector('.feature-sticky-variant-box--wrapper');
if (stickyVar) {
  stickyVar.addEventListener('click', function() {
    var ul = this.parentNode.querySelector('ul');
    ul.style.display = ul.style.display === 'none' || ul.style.display === '' ? 'block' : 'none';
  });
}

var stickysubPlan = document.querySelectorAll('.feature-sticky-subscription--wrapper span, .feature-sticky-subscription--wrapper svg');
stickysubPlan.forEach(function(element) {
  element.addEventListener('click', function() {
    var subPlanul = this.parentNode.querySelector('ul');
    subPlanul.style.display = subPlanul.style.display === 'none' || subPlanul.style.display === '' ? 'block' : 'none';
  });
});

var subDropdown = document.querySelectorAll('.feature-sticky-subscription--wrapper ul li');
subDropdown.forEach(function (item) {
  item.addEventListener('click', function () {
    var subPlan = this.getAttribute('data-plan');
    var subplantext = this.textContent;
    document.querySelector('.feature-sticky-subscription--wrapper span').innerHTML = subplantext;
    var planUl = item.closest('.feature-sticky-subscription--wrapper ul');
    if (planUl) {
        planUl.style.display = 'none';
    }
    var widgetOpt = document.querySelectorAll('.rc_widget__option');
    widgetOpt.forEach(function (swatchItem) {
        var widgetPlan = swatchItem.querySelector('.rc-option__text').textContent;
        if (widgetPlan == subPlan) {
          var parentLegacyRadio = swatchItem.closest('.rc_widget__option');
          if (parentLegacyRadio) {
            parentLegacyRadio.querySelector('.rc-radio__input').click();
          }
        }
    });
  });
});

stickyBar = document.querySelector(".featured-product-sticky-bar");
if(stickyBar){
  var scrolltoshow = function () {
      var y = window.scrollY;
      var productWrap = document.querySelector('.featured-product');
      if(productWrap){
        var heroHeight = document.querySelector('.hero--wrapper').offsetHeight;
        var panHeight = document.querySelector('.patented--wrapper').offsetHeight;
        var serHeight = document.querySelector('.service--wrapper').offsetHeight;
        var totalHeight = heroHeight + panHeight + serHeight;
        if (y >= totalHeight) {
            stickyBar.classList.add('show-bar'); 
        } else {
            stickyBar.classList.remove('show-bar'); 
        }
      }
      var mainProduct = document.querySelector('.main-product--sec');
      if (mainProduct) {
        var mainProductHeight = mainProduct.offsetHeight;
        if (y >= mainProductHeight) {
            stickyBar.classList.add('show-bar'); 
        } else {
            stickyBar.classList.remove('show-bar'); 
        }
      }
  };
  
  window.addEventListener("scroll", scrolltoshow);
}

// Featured Product section end

// Accordian start
let question = document.querySelectorAll(".faq-heading");

question.forEach(question => {
  question.addEventListener("click", event => {
    const active = document.querySelector(".faq-heading.active");
    if(active && active !== question ) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
      active.nextElementSibling.classList.remove('open-accordian');
    }
    question.classList.toggle("active");
    const answer = question.nextElementSibling;
    if(question.classList.contains("active")){
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.classList.add('open-accordian');
    } else {
      answer.style.maxHeight = 0;
      answer.classList.remove('open-accordian');
    }
  })
});
// Home Accordian End

document.addEventListener('DOMContentLoaded', function() {
  var itemWrappers = document.querySelectorAll('.cart__item-wrapper');
  if(itemWrappers.length > 0){    
    var footerWrappers = document.querySelectorAll('.cart__footer-wrapper');
    var wrapperDiv = document.createElement('div');
    wrapperDiv.className = 'main-cart--wrapper page-width';
    var parentElement = itemWrappers[0].parentNode;
    parentElement.insertBefore(wrapperDiv, itemWrappers[0]);
    itemWrappers.forEach(function(itemWrapper) {
        wrapperDiv.appendChild(itemWrapper);
    });
    footerWrappers.forEach(function(footerWrapper) {
        wrapperDiv.appendChild(footerWrapper);
    });
  }
});

// function freeShipping() {
//   fetch('/cart.js')
//   .then(response => response.json())
//   .then(cart => {
//     // Updated threshold value for free shipping (in cents)
//     var shippVal = 4000; // $60.00 represented in cents

//     var cart_total = parseInt(cart.total_price);
//     if (cart_total < shippVal) {
//       var total = shippVal;
//       var get_percentage = (((total - cart_total) * 100) / shippVal);
//       var final_per = (100 - get_percentage);
//       var price = (total - cart_total);
//       var formattedPrice = '$' + (price / 100).toFixed(2); // Formatting the price
//       var shippText = document.querySelector('.free-shipping-text');
//       var freeshippText = document.querySelector('.free-shipping-full-text');
//       var shippMoney = document.querySelector('.free-shipping-text .minus-money');
//       if(shippText){document.querySelector('.free-shipping-text').style.display = 'block';}
//       if(freeshippText){document.querySelector('.free-shipping-full-text').style.display = 'none';}
//       if(shippMoney){document.querySelector('.free-shipping-text .minus-money').innerHTML = formattedPrice;}
//       document.querySelectorAll('.ship-text-wrapper').forEach(function(parentElement) {
//         parentElement.querySelector('.free-ship').style.display = 'none';
//         parentElement.querySelector('.away-price').innerHTML = formattedPrice;
//         parentElement.querySelector('.shipp-away').style.display = 'block';
//       });
      
//     } else {
//       document.querySelectorAll('.ship-text-wrapper').forEach(function(parentElement) {
//         parentElement.querySelector('.shipp-away').style.display = 'none';
//         parentElement.querySelector('.free-ship').style.display = 'block';
//       });
//       if(shippText){document.querySelector('.free-shipping-text').style.display = 'none';}
//       if(freeshippText){document.querySelector('.free-shipping-full-text').style.display = 'block';}
//     }
//   });
// }

// freeShipping();

function drawerSlider() {  
  var swiper = new Swiper(".drawer-slider", {
    spaceBetween: 10,
    slidesPerView: 2,
    slidesOffsetBefore:20,
    slidesOffsetAfter:20,
    navigation: {
      nextEl: ".cart-drawer-next",
      prevEl: ".cart-drawer-prev",
    },
  });
}
drawerSlider();

// Cart Drawer Add to cart
function drawerAddtocart() {    
  var addToCartButtons = document.querySelectorAll(".cart-drawer .empty-collection-submit-btn");
  if (addToCartButtons) {
    addToCartButtons.forEach(function(button) {
      button.addEventListener("click", function(event) {
        event.preventDefault(); // Prevent default click behavior
        var variantId = button.getAttribute('varid');
        console.log('variantId',variantId);
        let formData = {
         'items': [{
          'id': variantId,
          'quantity': 1
          }]
        };    
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          fetch('/?section_id=cart-drawer', {
            method: 'GET',
            dataType: 'html'
          })
          .then(response => response.text())
          .then(carthtml => {
            document.querySelector('cart-drawer').innerHTML = new DOMParser().parseFromString(carthtml, 'text/html').querySelector('cart-drawer').innerHTML;
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));        
            drawerSlider();
            drawerAddtocart();
            freeShipping();
          })
          .catch(error => {
            console.error('Error:', error);
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });
    });
  }
}
drawerAddtocart();

// Product Slider
var swiper = new Swiper(".product-slider--wrapper", {
  autoplay: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// Product Ingrediants
var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth >= 768) {
    if (!init) {
      init = true;
      swiper = new Swiper(".ingredients-slider", {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination', // Specifies the element that will serve as the pagination container.
          clickable: true, // Makes the pagination indicators clickable.
          // dynamicBullets: true, // Optional: use if you want dynamic bullets that change size based on their proximity to the active slide.
        },
        navigation: {
          nextEl: '.swiper-button-next', // Specifies the element that will serve as the next button.
          prevEl: '.swiper-button-prev', // Specifies the element that will serve as the previous button.
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1360: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    }
  } else if (init) {
    console.log('trur')
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);


var swiper = new Swiper(".lp-product-thumbnail-img", {
  spaceBetween: 12,
  slidesPerView: 6.8,
  freeMode: true,
  watchSlidesProgress: true,
});
var swiper2 = new Swiper(".lp-product-main-img", {
  spaceBetween: 12,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiper,
  },
});